import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';
import { update } from '../../../common/api';


import '../modals.css';

const RenameList = ( { close, orgId, uid, lists, gid } ) => {
    const [ name, setName ] = useState( '' );
    
    const save = async () => {
        const g = lists[gid];

        if ( g ) {
            const resp = await update( orgId, g.aid, uid, 'group', gid, { label: name } );
            toast.success( 'Successfully updated list name to: ' + name, { theme: 'dark' } );
        } else {
            alert( 'Oops, looks like we have an error!  Please contact TF Support and let them know.' );
        }

        close();
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };


    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Rename This List</Col>
                </Row>
                <Row className='pt-2'>
                    <Col>The new name for this list is...</Col>
                </Row>
                <Row className='py-3'>
                    <Col><Form.Control className='tf-modal-text-input' type="text" placeholder="New List Name..." value={name} onChange={ ( e ) => setName( e.target.value ) } /></Col>
                    { name.length > 0 ? (
                        <Col xs='auto'>
                            <Button size='sm' variant='outline-primary' onClick={ () => save() }>Update</Button>
                        </Col>
                    ) : (
                        <Fragment />
                    ) }
                </Row>
            </Box>
            <ToastContainer autoClose={3000} />
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    uid: state.user.email,
    lists: state.lists.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( RenameList );